export const isEven = (number: number): boolean => Math.abs(number) % 2 === 0;
export const isOdd = (number: number): boolean => Math.abs(number) % 2 === 1;
